// src/components/LandingPage.jsx
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import SEOHead from './SEOHead'
import nLogo from '../n.png'

// ─── Icon primitive ──────────────────────────────────────────────────────────
const Ic = ({ size = 22, color = 'currentColor', sw = 1.8, children }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round"
    style={{ display: 'block', flexShrink: 0 }}>
    {children}
  </svg>
)

const I = {
  wave:     <Ic color="var(--teal)"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></Ic>,
  globe:    <Ic color="var(--teal)"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></Ic>,
  ai:       <Ic color="var(--teal)"><path d="M12 2C8.13 2 5 5.13 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.13 15.87 2 12 2Z"/><line x1="12" y1="22" x2="12" y2="18"/><line x1="9" y1="22" x2="15" y2="22"/></Ic>,
  monitor:  <Ic color="var(--green)"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></Ic>,
  map:      <Ic color="var(--amber)"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/><line x1="8" y1="2" x2="8" y2="18"/><line x1="16" y1="6" x2="16" y2="22"/></Ic>,
  lock:     <Ic color="var(--teal)"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></Ic>,
  bell:     <Ic color="var(--red)"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/></Ic>,
  chip:     <Ic color="var(--blue)"><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/><line x1="20" y1="9" x2="23" y2="9"/><line x1="20" y1="14" x2="23" y2="14"/><line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/></Ic>,
  clock:    <Ic color="var(--green)"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></Ic>,
  search:   <Ic color="var(--teal)"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></Ic>,
  home:     <Ic size={18} color="var(--teal)"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></Ic>,
  slash:    <Ic size={18} color="var(--red)"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></Ic>,
  inbox:    <Ic size={18} color="var(--blue)"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z"/></Ic>,
  github:   <Ic size={18} color="var(--green)"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22"/></Ic>,
  eye:      <Ic size={18} color="var(--teal)"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></Ic>,
  shield:   <Ic size={18} color="var(--amber)"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></Ic>,
  power:    <Ic color="var(--red)"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></Ic>,
  shield2:  <Ic color="var(--amber)"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></Ic>,
  menubar:  <Ic color="var(--teal)"><rect x="2" y="3" width="20" height="4" rx="1"/><line x1="12" y1="7" x2="12" y2="21"/><line x1="8" y1="13" x2="16" y2="13"/></Ic>,
  notify:   <Ic color="var(--blue)"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/><line x1="12" y1="2" x2="12" y2="4"/></Ic>,
  chevR:    <Ic size={14} color="currentColor" sw={2}><polyline points="9 18 15 12 9 6"/></Ic>,
  warn:     <Ic size={14} color="var(--amber)" sw={2}><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></Ic>,
  menu:     <Ic size={22} color="var(--text)" sw={2}><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></Ic>,
  close:    <Ic size={22} color="var(--text)" sw={2}><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></Ic>,
  forever:  <Ic color="var(--teal)"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></Ic>,
}

// ─── Helpers ─────────────────────────────────────────────────────────────────
function scrollTo(id) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
}

function Dot() {
  return <div style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--teal)',
    boxShadow: '0 0 8px var(--teal)', animation: 'nw-pulse 2s ease-in-out infinite', flexShrink: 0 }} />
}

function SpeedWave({ color, type }) {
  const canvasRef = useRef(null)
  const animRef   = useRef(null)
  const smoothIn  = useRef(new Float32Array(30))
  const smoothOut = useRef(new Float32Array(30))
  const targetsIn = useRef(new Float32Array(30))
  const targetsOut = useRef(new Float32Array(30))

  // Initialize with dynamic starting values for immediate visual impact
  useEffect(() => {
    for (let i = 0; i < 30; i++) {
      targetsIn.current[i] = 0.2 + Math.random() * 0.4
      targetsOut.current[i] = 0.1 + Math.random() * 0.2
      smoothIn.current[i] = targetsIn.current[i]
      smoothOut.current[i] = targetsOut.current[i]
    }
  }, [])
  const [currentSpeed, setCurrentSpeed] = useState(type === 'dl' ? 3.42 : 0.87)

  useEffect(() => {
    const iv = setInterval(() => {
      const newSpeed = type === 'dl'
        ? 1.2 + Math.random() * 4.5  // 1.2 - 5.7 MB/s download
        : 0.3 + Math.random() * 1.4  // 0.3 - 1.7 MB/s upload
      setCurrentSpeed(newSpeed)
    }, 2000)
    return () => clearInterval(iv)
  }, [type])

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return

    canvas.width = canvas.offsetWidth || 200
    canvas.height = canvas.offsetHeight || 60

    const ctx = canvas.getContext('2d')
    let running = true
    let tick = 0

    function drawWave(ctx, smoothedIn, smoothedOut, max, H, W) {
      const halfH = H / 2
      
      // Center divider line
      ctx.beginPath()
      ctx.moveTo(0, halfH)
      ctx.lineTo(W, halfH)
      ctx.strokeStyle = 'rgba(255,255,255,0.06)'
      ctx.lineWidth = 1
      ctx.stroke()

      // In — blue, grows from center upward
      const ptsIn = Array.from(smoothedIn).map((v, i) => ({
        x: (i / 29) * W,
        y: halfH - (v / max) * halfH * 0.9,
      }))

      ctx.beginPath()
      ctx.moveTo(0, halfH)
      for (const p of ptsIn) ctx.lineTo(p.x, p.y)
      ctx.lineTo(W, halfH)
      ctx.closePath()
      ctx.fillStyle = 'rgba(77,157,224,0.2)'
      ctx.fill()

      ctx.beginPath()
      ctx.moveTo(ptsIn[0].x, ptsIn[0].y)
      for (let i = 1; i < ptsIn.length; i++) {
        const mx = (ptsIn[i-1].x + ptsIn[i].x) / 2
        ctx.quadraticCurveTo(ptsIn[i-1].x, ptsIn[i-1].y, mx, (ptsIn[i-1].y + ptsIn[i].y) / 2)
      }
      ctx.strokeStyle = '#4d9de0'
      ctx.lineWidth = 1.2
      ctx.globalAlpha = 0.9
      ctx.stroke()
      ctx.globalAlpha = 1

      // Out — red/coral, grows from center downward
      const ptsOut = Array.from(smoothedOut).map((v, i) => ({
        x: (i / 29) * W,
        y: halfH + (v / max) * halfH * 0.9,
      }))

      ctx.beginPath()
      ctx.moveTo(0, halfH)
      for (const p of ptsOut) ctx.lineTo(p.x, p.y)
      ctx.lineTo(W, halfH)
      ctx.closePath()
      ctx.fillStyle = 'rgba(239,100,100,0.18)'
      ctx.fill()

      ctx.beginPath()
      ctx.moveTo(ptsOut[0].x, ptsOut[0].y)
      for (let i = 1; i < ptsOut.length; i++) {
        const mx = (ptsOut[i-1].x + ptsOut[i].x) / 2
        ctx.quadraticCurveTo(ptsOut[i-1].x, ptsOut[i-1].y, mx, (ptsOut[i-1].y + ptsOut[i].y) / 2)
      }
      ctx.strokeStyle = '#ef6464'
      ctx.lineWidth = 1.2
      ctx.globalAlpha = 0.85
      ctx.stroke()
      ctx.globalAlpha = 1
    }

    function draw(ts) {
      if (!running) return
      if (ts - lastFrame.current < 100) { animRef.current = requestAnimationFrame(draw); return }
      if (document.hidden || !document.hasFocus()) { animRef.current = requestAnimationFrame(draw); return }
      lastFrame.current = ts

      const W = canvas.offsetWidth
      const H = canvas.offsetHeight
      if (canvas.width !== W || canvas.height !== H) { canvas.width = W; canvas.height = H }

      tick++

      // Update targets based on current speed
      if (tick % 20 === 0) {
        for (let i = 0; i < 29; i++) {
          targetsIn.current[i] = targetsIn.current[i + 1]
          targetsOut.current[i] = targetsOut.current[i + 1]
        }
        
        // Use current speed to determine wave height with more variation
        const speedHeight = Math.min(0.8, Math.max(0.1, currentSpeed / 1000000))
        
        if (type === 'dl') {
          // Download: populate incoming wave with more variation
          targetsIn.current[29] = speedHeight + (Math.random() - 0.5) * 0.3
          targetsOut.current[29] = 0.05 + Math.random() * 0.15 // More upload variation
        } else {
          // Upload: populate outgoing wave with more variation
          targetsOut.current[29] = speedHeight + (Math.random() - 0.5) * 0.3
          targetsIn.current[29] = 0.05 + Math.random() * 0.15 // More download variation
        }
      }

      // Always lerp
      for (let i = 0; i < 30; i++) {
        smoothIn.current[i] += (targetsIn.current[i] - smoothIn.current[i]) * 0.25
        smoothOut.current[i] += (targetsOut.current[i] - smoothOut.current[i]) * 0.25
      }

      const maxIn = Math.max(...smoothIn.current, 1)
      const maxOut = Math.max(...smoothOut.current, 1)
      const globalMax = Math.max(maxIn, maxOut)
      
      ctx.clearRect(0, 0, W, H)
      drawWave(ctx, smoothIn.current, smoothOut.current, globalMax, H, W)

      animRef.current = requestAnimationFrame(draw)
    }

    let lastFrame = { current: 0 }
    animRef.current = requestAnimationFrame(draw)
    return () => { running = false; cancelAnimationFrame(animRef.current) }
  }, [color])

  return (
    <canvas
      ref={canvasRef}
      width={200}
      height={60}
      style={{ display: 'block', width: '100%', height: 60, marginTop: 8 }}
    />
  )
}

function PreviewRing({ pct, color }) {
  const r = 14, stroke = 3, circ = 2 * Math.PI * r
  return (
    <svg width={36} height={36} style={{ transform: 'rotate(-90deg)', flexShrink: 0 }}>
      <circle cx={18} cy={18} r={r} fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth={stroke} />
      <circle cx={18} cy={18} r={r} fill="none" stroke={color} strokeWidth={stroke}
        strokeLinecap="round" strokeDasharray={circ}
        strokeDashoffset={circ * (1 - pct / 100)}
        style={{ transition: 'stroke-dashoffset 0.6s ease' }} />
    </svg>
  )
}

function AnimSpeed({ type }) {
  const [val, setVal] = useState(type === 'dl' ? 3.42 : 0.87)
  useEffect(() => {
    const iv = setInterval(() => {
      setVal(type === 'dl'
        ? +(1.2 + Math.random() * 4.5).toFixed(2)
        : +(0.3 + Math.random() * 1.4).toFixed(2))
    }, 2000)
    return () => clearInterval(iv)
  }, [type])
  return <span style={{ transition: 'opacity 0.3s' }}>{val} MB/s</span>
}

function AnimConnCount() {
  const [count, setCount] = useState(12)
  useEffect(() => {
    const iv = setInterval(() => setCount(10 + Math.floor(Math.random() * 8)), 4000)
    return () => clearInterval(iv)
  }, [])
  return <>{count} active connections</>
}

// ─── Cinematic kill animation sequence ───────────────────────────────────────
// Phase timeline (seconds):
// 0-3   normal state
// 3-4   safari card pulses/glows amber warning
// 4-5   card expands showing detail + Kill button
// 5-6   kill button highlights red
// 6-7   confirmation modal fades in
// 7-8   confirm clicked — card shakes
// 8-9   card shrinks and disappears with power-down
// 9-10  success banner flashes green
// 10-13 clean state (safari gone)
// 13    loop reset

function AnimConnections() {
  const [phase, setPhase] = useState(0)
  const [shake, setShake] = useState(false)
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const durations = [3000, 1000, 1000, 1200, 2000, 2000, 1500, 1000, 1000, 1000, 1000, 1000, 500, 3000]
    let current = 0
    let t

    function advance() {
      current = (current + 1) % 14
      setPhase(current)

      if (current === 12) {
        setShake(true)
        setTimeout(() => setShake(false), 500)
      }
      if (current === 13) setVisible(false)
      if (current === 0) setVisible(true)

      t = setTimeout(advance, durations[current] || 1500)
    }

    t = setTimeout(advance, 3000)

    return () => clearTimeout(t)
  }, [])

  // Phase timeline (seconds):
  // 0-3   normal state
  // 3-4   safari card pulses/glows red warning
  // 4-5   card expands showing detail + buttons
  // 5-6   AI button glows — user clicks it
  // 6-8   AI loading spinner
  // 8-10  AI response types in
  // 10-11 kill button highlights red
  // 11-12 confirmation modal
  // 12-13 card shakes + disappears
  // 13-14 success banner
  // 14-17 clean state
  // 17    loop reset

  const isGlowing   = phase >= 1 && phase <= 13
  const isExpanded  = phase >= 2 && phase <= 13
  const aiGlows     = phase === 3
  const aiLoading   = phase >= 4 && phase <= 5
  const aiDone      = phase >= 6 && phase <= 13
  const killGlows   = phase >= 8 && phase <= 13
  const showModal   = phase >= 9 && phase <= 11
  const showSuccess = phase === 13
  const safariGone  = !visible && phase >= 13

  return (
    <div style={{ padding: '10px 12px', position: 'relative' }}>

      {/* ── NORMAL CARDS ── */}
      <ConnRow name="Mail securely connected to 1e100.net"
        country="🇺🇸 United States" />
      <ConnRow name={`Chrome securely connected to google.com`}
        country="🇺🇸 United States" />

      {/* ── SAFARI CARD — animated ── */}
      {visible && (
        <div style={{
          borderRadius: 9, marginBottom: 5, overflow: 'hidden',
          border: `1px solid ${isGlowing ? 'rgba(239,68,68,0.6)' : 'rgba(245,166,35,0.22)'}`,
          background: isGlowing ? 'rgba(239,68,68,0.07)' : 'rgba(245,166,35,0.04)',
          boxShadow: isGlowing ? '0 0 16px rgba(239,68,68,0.2)' : 'none',
          transform: shake ? 'translateX(6px)' : 'translateX(0)',
          opacity: phase === 8 ? 0 : 1,
          transition: 'all 0.3s ease, transform 0.08s ease, opacity 0.4s ease',
          animation: shake ? 'lp-shake 0.4s ease' : 'none',
        }}>
          {/* Card header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 10px' }}>
            <div style={{ width: 28, height: 28, borderRadius: 7, flexShrink: 0,
              background: 'rgba(245,166,35,0.15)',
              display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#f5a623"
                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </div>
            <div style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
              <div style={{ fontSize: 11, fontWeight: 500, color: 'rgba(220,232,245,0.9)',
                fontFamily: "'IBM Plex Mono', monospace", marginBottom: 2, textAlign: 'left' }}>
                Safari connected to tehran-media.ir — unencrypted
              </div>
              <div className="preview-conn-detail" style={{ fontSize: 9, color: 'rgba(220,232,245,0.35)', fontFamily: 'var(--font-mono)', textAlign: 'left' }}>
                🇮🇷 Iran
              </div>
            </div>
            <div style={{ fontSize: 9, color: 'rgba(220,232,245,0.2)', flexShrink: 0,
              transform: isExpanded ? 'rotate(180deg)' : 'rotate(0)',
              transition: 'transform 0.3s ease' }}>▼</div>
          </div>

          {/* Expanded detail */}
          {isExpanded && (
            <div style={{
              borderTop: '1px solid rgba(255,255,255,0.06)',
              padding: '10px 12px',
              background: 'rgba(0,0,0,0.3)',
              animation: 'lp-slidedown 0.3s ease',
            }}>
              {/* Detail grid */}
              <div className="preview-detail-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginBottom: 10 }}>
                {[
                  ['Remote IP', '185.220.101.47'],
                  ['Port', '80'],
                  ['Protocol', 'IPv4'],
                  ['Domain', 'tehran-media.ir'],
                  ['Country', '🇮🇷 Iran'],
                  ['App PID', '3456'],
                ].map(([label, val]) => (
                  <div key={label}>
                    <div style={{ fontSize: 8, color: 'rgba(220,232,245,0.3)',
                      textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 2,
                      textAlign: 'left' }}>{label}</div>
                    <div style={{ fontSize: 10, color: '#dce8f5',
                      fontFamily: "'IBM Plex Mono', monospace", textAlign: 'left' }}>{val}</div>
                  </div>
                ))}
              </div>

              {/* Action buttons */}
              <div style={{ display: 'flex', gap: 6, marginBottom: aiLoading || aiDone ? 10 : 0 }}>
                <div style={{
                  display: 'inline-flex', alignItems: 'center', gap: 5,
                  padding: '5px 10px', borderRadius: 6,
                  background: killGlows ? 'rgba(239,68,68,0.2)' : 'rgba(239,68,68,0.08)',
                  border: `1px solid ${killGlows ? 'rgba(239,68,68,0.6)' : 'rgba(239,68,68,0.25)'}`,
                  boxShadow: killGlows ? '0 0 12px rgba(239,68,68,0.3)' : 'none',
                  color: '#ef4444', fontSize: 10, fontWeight: 600,
                  transition: 'all 0.3s ease', cursor: 'pointer',
                }}>
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
                  </svg>
                  Kill Process
                </div>
                <div style={{
                  display: 'inline-flex', alignItems: 'center', gap: 5,
                  padding: '5px 10px', borderRadius: 6,
                  background: 'rgba(245,166,35,0.07)',
                  border: '1px solid rgba(245,166,35,0.2)',
                  color: '#f5a623', fontSize: 10, fontWeight: 600,
                }}>
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                  </svg>
                  Block IP
                </div>
                {/* AI button */}
                <div style={{
                  display: 'inline-flex', alignItems: 'center', gap: 5,
                  padding: '5px 10px', borderRadius: 6,
                  background: aiGlows ? 'rgba(0,212,184,0.15)' : 'rgba(0,212,184,0.07)',
                  border: `1px solid ${aiGlows ? 'rgba(0,212,184,0.5)' : 'rgba(0,212,184,0.2)'}`,
                  boxShadow: aiGlows ? '0 0 12px rgba(0,212,184,0.25)' : 'none',
                  color: '#00d4b8', fontSize: 10, fontWeight: 600,
                  transition: 'all 0.3s ease', cursor: 'pointer',
                }}>
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                  </svg>
                  Ask AI to explain this
                </div>
              </div>

              {/* AI loading state */}
              {aiLoading && (
                <div style={{
                  display: 'flex', alignItems: 'center', gap: 7,
                  padding: '8px 10px', borderRadius: 7,
                  background: 'rgba(0,212,184,0.05)', border: '1px solid rgba(0,212,184,0.15)',
                  animation: 'lp-fadein 0.3s ease',
                }}>
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none"
                    stroke="#00d4b8" strokeWidth="2.5" strokeLinecap="round"
                    style={{ animation: 'lp-spin 0.8s linear infinite', flexShrink: 0 }}>
                    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
                  </svg>
                  <span style={{ fontSize: 9, color: 'rgba(220,232,245,0.5)', fontFamily: 'var(--font-mono)' }}>
                    Asking AI to explain this connection…
                  </span>
                </div>
              )}

              {/* AI response */}
              {aiDone && (
                <div style={{
                  padding: '9px 11px', borderRadius: 7,
                  background: 'rgba(0,212,184,0.05)', border: '1px solid rgba(0,212,184,0.2)',
                  animation: 'lp-fadein 0.5s ease',
                }}>
                  <div style={{ fontSize: 9, fontFamily: "'IBM Plex Mono', monospace", color: '#00d4b8',
                    textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 5, textAlign: 'left' }}>
                    AI Explanation · llama 3.2
                  </div>
                  <p className="preview-ai-text" style={{ fontSize: 11, color: '#dce8f5', lineHeight: 1.65,
                    margin: 0, fontWeight: 300, fontFamily: "'IBM Plex Sans', sans-serif",
                    textAlign: 'left' }}>
                    This connection is suspicious. Safari is transmitting data in plain text to a server in Iran on port 80 — anyone on your network can read this traffic. The domain <strong style={{ color: '#dce8f5' }}>tehran-media.ir</strong> has no known legitimate association with Safari. Use Kill Process or Block IP to stop this immediately.
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {/* ── CONFIRMATION MODAL ── */}
      {showModal && (
        <div style={{
          position: 'absolute', inset: 0, zIndex: 10,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'rgba(4,6,13,0.7)', backdropFilter: 'blur(4px)',
          borderRadius: 12,
          animation: 'lp-fadein 0.25s ease',
        }}>
          <div style={{
            background: '#0d1220', border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 10, padding: '16px 18px', maxWidth: 240, width: '90%',
            boxShadow: '0 16px 48px rgba(0,0,0,0.6)',
          }}>
            <div className="preview-modal-title" style={{ fontSize: 12, fontWeight: 600, color: '#dce8f5', marginBottom: 6, textAlign: 'left' }}>
              Kill Safari?
            </div>
            <div className="preview-modal-body" style={{ fontSize: 10, color: 'rgba(220,232,245,0.5)', lineHeight: 1.6, marginBottom: 14, textAlign: 'left' }}>
              This will terminate Safari (PID 3456) immediately.
            </div>
            <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-start' }}>
              <div style={{ padding: '4px 10px', borderRadius: 6, fontSize: 10,
                background: 'none', border: '1px solid rgba(255,255,255,0.1)',
                color: 'rgba(220,232,245,0.5)' }}>Cancel</div>
              <div style={{
                padding: '4px 10px', borderRadius: 6, fontSize: 10, fontWeight: 700,
                background: phase === 10 ? 'rgba(239,68,68,0.25)' : 'rgba(239,68,68,0.12)',
                border: '1px solid rgba(239,68,68,0.5)',
                color: '#ef4444',
                boxShadow: phase === 10 ? '0 0 12px rgba(239,68,68,0.3)' : 'none',
                transition: 'all 0.2s',
                transform: phase === 11 ? 'scale(0.92)' : 'scale(1)',
                transition: 'all 0.2s',
              }}>Kill Process</div>
            </div>
          </div>
        </div>
      )}

      {/* ── SUCCESS BANNER ── */}
      {showSuccess && (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 8,
          padding: '8px 12px', borderRadius: 8, marginBottom: 5,
          background: 'rgba(62,207,142,0.1)', border: '1px solid rgba(62,207,142,0.3)',
          animation: 'lp-fadein 0.3s ease',
        }}>
          <span style={{ fontSize: 14 }}>✅</span>
          <span style={{ fontSize: 10, color: '#3ecf8e', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>
            Safari (PID 3456) was terminated successfully.
          </span>
        </div>
      )}

      {/* ── ALERT ── */}
      {!safariGone && (
        <div style={{
          display: 'flex', alignItems: 'flex-start', gap: 8, padding: '9px 11px',
          marginTop: 4, background: 'rgba(245,166,35,0.05)',
          border: '1px solid rgba(245,166,35,0.2)', borderRadius: 8,
          opacity: isGlowing ? 1 : phase === 0 ? 0.35 : 0,
          transition: 'opacity 0.6s ease',
        }}>
          {I.warn}
          <div style={{ fontSize: 9, color: 'rgba(220,232,245,0.55)', lineHeight: 1.5 }}>
            <strong style={{ color: 'var(--amber)' }}>Safari</strong> is sending unencrypted data to a server in Iran.
          </div>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: 7, padding: '2px 5px',
            borderRadius: 3, background: 'rgba(245,166,35,0.18)', color: 'var(--amber)',
            whiteSpace: 'nowrap', flexShrink: 0 }}>WARNING</div>
        </div>
      )}
    </div>
  )
}

// ─── Canvas particles ─────────────────────────────────────────────────────────
function ParticleCanvas() {
  const ref = useRef(null)
  useEffect(() => {
    const canvas = ref.current
    const ctx = canvas?.getContext('2d')
    if (!canvas || !ctx) return

    const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const pointer = { x: -9999, y: -9999, strength: 0, last: 0 }
    const colors = [
      [0, 212, 184],
      [77, 157, 224],
      [62, 207, 142],
    ]
    let points = []
    let projected = []
    let raf
    let width = 0
    let height = 0
    let dpr = 1
    let radius = 260
    let centerX = 0
    let centerY = 0
    let lastFrame = 0

    const rgba = (rgb, alpha) => `rgba(${rgb[0]},${rgb[1]},${rgb[2]},${alpha})`

    function resize() {
      dpr = Math.min(window.devicePixelRatio || 1, 2)
      width = window.innerWidth
      height = window.innerHeight
      canvas.width = Math.floor(width * dpr)
      canvas.height = Math.floor(height * dpr)
      canvas.style.width = `${width}px`
      canvas.style.height = `${height}px`
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0)

      centerX = width / 2
      centerY = height * (width < 700 ? 0.42 : 0.48)
      radius = Math.min(width * 0.68, height * 0.55, width < 700 ? 340 : 720)

      const count = width < 700 ? 132 : 240
      const offset = 2 / count
      const increment = Math.PI * (3 - Math.sqrt(5))
      points = Array.from({ length: count }, (_, i) => {
        const y = ((i * offset) - 1) + (offset / 2)
        const r = Math.sqrt(Math.max(0, 1 - y * y))
        const phi = i * increment
        return {
          x: Math.cos(phi) * r,
          y,
          z: Math.sin(phi) * r,
          phase: Math.random() * Math.PI * 2,
          color: colors[i % colors.length],
        }
      })
    }

    function movePointer(x, y) {
      pointer.x = x
      pointer.y = y
      pointer.strength = 1
      pointer.last = performance.now()
    }

    function onPointerMove(e) {
      movePointer(e.clientX, e.clientY)
    }

    function onTouchMove(e) {
      const t = e.touches?.[0]
      if (t) movePointer(t.clientX, t.clientY)
    }

    function draw(ts) {
      // Cap the background at ~30fps so the landing page stays light.
      if (ts - lastFrame < 33) { raf = requestAnimationFrame(draw); return }
      lastFrame = ts
      if (document.hidden || !document.hasFocus()) { raf = requestAnimationFrame(draw); return }

      if (performance.now() - pointer.last > 1200) pointer.strength *= 0.92
      pointer.strength = Math.max(0, Math.min(1, pointer.strength))

      const time = reducedMotion ? 0 : ts * 0.00028
      const pointerNX = pointer.strength ? (pointer.x / width - 0.5) : 0
      const pointerNY = pointer.strength ? (pointer.y / height - 0.5) : 0
      const rotY = time + pointerNX * 0.55
      const rotX = -0.18 + Math.sin(time * 0.9) * 0.1 - pointerNY * 0.38
      const cosY = Math.cos(rotY)
      const sinY = Math.sin(rotY)
      const cosX = Math.cos(rotX)
      const sinX = Math.sin(rotX)
      const influence = width < 700 ? 130 : 190

      projected = points.map((p) => {
        const x1 = p.x * cosY - p.z * sinY
        const z1 = p.x * sinY + p.z * cosY
        const y1 = p.y * cosX - z1 * sinX
        const z2 = p.y * sinX + z1 * cosX
        const perspective = 1.15 / (1.55 - z2 * 0.42)

        let x = centerX + x1 * radius * perspective
        let y = centerY + y1 * radius * perspective
        const dx = x - pointer.x
        const dy = y - pointer.y
        const dist = Math.sqrt(dx * dx + dy * dy) || 1
        const near = pointer.strength * Math.max(0, 1 - dist / influence)

        if (near > 0) {
          const push = near * near * (width < 700 ? 34 : 52)
          x += (dx / dist) * push
          y += (dy / dist) * push
        }

        const depth = Math.max(0, Math.min(1, (z2 + 1) / 2))
        const pulse = 0.72 + Math.sin(ts * 0.002 + p.phase) * 0.28
        return { x, y, z: z2, depth, near, pulse, color: p.color }
      })

      ctx.clearRect(0, 0, width, height)
      ctx.save()
      ctx.globalCompositeOperation = 'lighter'

      const maxLineDist = width < 700 ? 72 : 96
      for (let i = 0; i < projected.length; i++) {
        for (let j = i + 1; j < projected.length; j++) {
          const a = projected[i]
          const b = projected[j]
          const dx = a.x - b.x
          const dy = a.y - b.y
          const dist = Math.sqrt(dx * dx + dy * dy)
          if (dist > maxLineDist) continue
          const depth = Math.max(0.12, (a.depth + b.depth) / 2)
          const touchLift = Math.max(a.near, b.near) * 0.16
          const alpha = (1 - dist / maxLineDist) * depth * 0.18 + touchLift
          ctx.beginPath()
          ctx.moveTo(a.x, a.y)
          ctx.lineTo(b.x, b.y)
          ctx.strokeStyle = rgba(a.depth > b.depth ? a.color : b.color, Math.min(0.32, alpha))
          ctx.lineWidth = 0.55 + Math.max(a.near, b.near) * 0.7
          ctx.stroke()
        }
      }

      if (pointer.strength > 0.02) {
        for (const p of projected) {
          if (p.near <= 0) continue
          ctx.beginPath()
          ctx.moveTo(pointer.x, pointer.y)
          ctx.lineTo(p.x, p.y)
          ctx.strokeStyle = `rgba(245,166,35,${p.near * 0.13})`
          ctx.lineWidth = 0.45
          ctx.stroke()
        }
      }

      for (const p of projected.sort((a, b) => a.z - b.z)) {
        const size = 0.65 + p.depth * 1.65 + p.near * 2.2
        const alpha = Math.min(0.9, 0.18 + p.depth * 0.5 + p.near * 0.35) * p.pulse
        ctx.beginPath()
        ctx.arc(p.x, p.y, size, 0, Math.PI * 2)
        ctx.fillStyle = rgba(p.color, alpha)
        ctx.fill()
      }

      ctx.restore()
      raf = requestAnimationFrame(draw)
    }

    resize()
    window.addEventListener('resize', resize)
    window.addEventListener('pointermove', onPointerMove, { passive: true })
    window.addEventListener('touchmove', onTouchMove, { passive: true })
    raf = requestAnimationFrame(draw)

    return () => {
      window.removeEventListener('resize', resize)
      window.removeEventListener('pointermove', onPointerMove)
      window.removeEventListener('touchmove', onTouchMove)
      cancelAnimationFrame(raf)
    }
  }, [])
  return <canvas ref={ref} style={{ position: 'fixed', inset: 0, zIndex: 0, pointerEvents: 'none' }} />
}

// ─── Scroll reveal ────────────────────────────────────────────────────────────
function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll('.nw-reveal')
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('nw-visible'); obs.unobserve(e.target) } })
    }, { threshold: 0.08 })
    els.forEach(el => obs.observe(el))
    return () => obs.disconnect()
  }, [])
}

// ─── Feature card ─────────────────────────────────────────────────────────────
function FCard({ icon, iconBg, title, desc }) {
  const [h, setH] = useState(false)
  return (
    <div className="nw-reveal" onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
      style={{ background: 'var(--surface)', border: `1px solid ${h ? 'rgba(0,212,184,0.22)' : 'var(--border)'}`,
        borderRadius: 12, padding: '14px 16px', transition: 'border-color .25s, transform .25s',
        transform: h ? 'translateY(-3px)' : 'none', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 1,
        background: 'linear-gradient(90deg,transparent,var(--teal),transparent)', opacity: h ? 1 : 0, transition: 'opacity .3s' }} />
      <div style={{ width: 44, height: 44, borderRadius: 10, background: iconBg,
        display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>{icon}</div>
      <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 8, color: 'var(--text)', letterSpacing: '-0.01em', fontFamily: 'var(--font-display)' }}>{title}</div>
      <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.7, fontWeight: 300 }}>{desc}</div>
    </div>
  )
}

// ─── Privacy card ─────────────────────────────────────────────────────────────
function PCard({ icon, iconBg, title, desc }) {
  return (
    <div className="nw-reveal" style={{ display: 'flex', gap: 16, alignItems: 'flex-start',
      padding: 20, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12, 
      transition: 'all 0.3s ease', cursor: 'pointer' }}
      onMouseEnter={e => { e.currentTarget.style.border='1px solid rgba(0,212,184,0.4)'; e.currentTarget.style.boxShadow='0 0 20px rgba(0,212,184,0.3), 0 0 40px rgba(0,212,184,0.15)'; e.currentTarget.style.transform='translateY(-2px)' }}
      onMouseLeave={e => { e.currentTarget.style.border='1px solid var(--border)'; e.currentTarget.style.boxShadow='none'; e.currentTarget.style.transform='translateY(0)' }}>
      <div style={{ width: 36, height: 36, borderRadius: 8, background: iconBg,
        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{icon}</div>
      <div>
        <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 5, letterSpacing: '-0.01em' }}>{title}</div>
        <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.65, fontWeight: 300 }}>{desc}</div>
      </div>
    </div>
  )
}

function OllamaMascot() {
  return (
    <div className="ollama-mascot">
      <img src="/ollama.png" alt="Ollama" className="ollama-mascot-img" />
      <svg className="ollama-face" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
        <ellipse className="ollama-wink-cover" cx="32.4" cy="22.2" rx="4.4" ry="5.3" />
        <path className="ollama-wink-line" d="M28.9 22.2 Q32.4 24.1 35.9 22.2" />
        <path className="ollama-smile" d="M20.1 29.5 Q24 33.7 27.9 29.5" />
      </svg>
    </div>
  )
}

// ─── Step ─────────────────────────────────────────────────────────────────────
function Step({ num, title, desc, code, copyCommand }) {
  const [copied, setCopied] = React.useState(false)
  
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(copyCommand)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }
  
  return (
    <div className="nw-reveal" style={{ display: 'flex', gap: 16, padding: '20px 0', alignItems: 'flex-start' }}>
      <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'var(--surface)',
        border: '1px solid var(--border2)', display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: 'var(--font-mono)', fontSize: 11, fontWeight: 600, color: 'var(--teal)',
        flexShrink: 0, position: 'relative', zIndex: 1 }}>{num}</div>
      <div style={{ flex: 1, paddingTop: 4 }}>
        <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 8, letterSpacing: '-0.015em', fontFamily: 'var(--font-display)' }}>{title}</div>
        <div style={{ fontSize: 14, color: 'var(--muted)', lineHeight: 1.75, fontWeight: 300 }}>{desc}</div>
        {code && (
          <div style={{ position: 'relative' }}>
            <div style={{
              marginTop: 12,
              background: '#0a0f1a',
              border: '1px solid rgba(255,255,255,0.08)',
              borderRadius: 8, padding: '10px 12px',
              fontFamily: 'var(--font-mono)', fontSize: 11,
              color: 'rgba(220,232,245,0.7)', lineHeight: 2,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-all',
            }}>
              {code.split('\n').map((line, i) => (
                <div key={i} style={{
                  color: line.startsWith('xattr') || line.startsWith('/Applications') ? '#f5a623'
                       : line.startsWith('') ? '#dce8f5'
                       : line.includes('Not encrypted') ? '#f5a623'
                       : line.includes('Encrypted') ? '#3ecf8e'
                       : 'rgba(220,232,245,0.4)',
                }}>{line}</div>
              ))}
            </div>
            {copyCommand && (
              <button
                onClick={handleCopy}
                style={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  background: 'transparent',
                  border: 'none',
                  borderRadius: 4,
                  padding: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.1)'
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = 'transparent'
                }}
              >
                {copied ? (
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3ecf8e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                ) : (
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(220,232,245,0.6)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                    <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"></path>
                  </svg>
                )}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

// ─── Conn row in preview ──────────────────────────────────────────────────────
function ConnRow({ name, country, warn }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 10px',
      borderRadius: 9, marginBottom: 5,
      background: warn ? 'rgba(245,166,35,0.04)' : 'rgba(255,255,255,0.02)',
      border: `1px solid ${warn ? 'rgba(245,166,35,0.22)' : 'rgba(255,255,255,0.07)'}` }}>
      {/* Lock icon */}
      <div style={{ width: 28, height: 28, borderRadius: 7, flexShrink: 0,
        background: warn ? 'rgba(245,166,35,0.1)' : 'rgba(62,207,142,0.1)',
        display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {warn
          ? <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#f5a623" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
          : <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#3ecf8e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
        }
      </div>
      {/* Text */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 11, fontWeight: 500, color: 'rgba(220,232,245,0.9)',
          whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
          marginBottom: 2, fontFamily: "'IBM Plex Mono', monospace", textAlign: 'left' }}>{name}</div>
        <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 9,
          color: 'rgba(220,232,245,0.35)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'left' }}>
          {country}
        </div>
      </div>
      {/* Chevron */}
      <div style={{ fontSize: 9, color: 'rgba(220,232,245,0.2)', flexShrink: 0 }}>▼</div>
    </div>
  )
}

// ─── Testimonial data ─────────────────────────────────────────────────────────
const ROW1 = [
  { quote: "Finally an app that just tells me what's happening on my network in plain English. I've been looking for this for years.", handle: '@mkbhd_fan', role: 'Mac Power User', color: '#00d4b8' },
  { quote: "The AI explanations are genuinely useful. I had no idea what half these processes were. Now I do — and I killed three of them immediately.", handle: '@privacymatters', role: 'Security Researcher', color: '#4d9de0' },
  { quote: "As a developer I run localhost all day. Glad it doesn't alert me on that. Smart app.", handle: '@fullstackdev', role: 'Software Engineer', color: '#3ecf8e' },
  { quote: "No subscription. No account. No BS. One time payment and it just works. This is how software should be.", handle: '@antisubscription', role: 'Indie Hacker', color: '#f5a623' },
  { quote: "My Mac was connecting to servers in countries I've never visited. Netwoke caught it in the first hour.", handle: '@paranoiduser', role: 'Privacy Enthusiast', color: '#00d4b8' },
  { quote: "Saw something suspicious, asked AI what it was, killed it. Done. The whole thing took 10 seconds.", handle: '@techskeptic99', role: 'IT Professional', color: '#4d9de0' },
]

const ROW2 = [
  { quote: "Got an alert about a VPN app connecting to a server in Russia that I forgot I installed. Deleted immediately. Worth every penny.", handle: '@casualmacuser', role: 'Graphic Designer', color: '#3ecf8e' },
  { quote: "The menu bar mode is perfect. Live speeds always visible, full dashboard one click away. Feels native.", handle: '@macminimalist', role: 'Product Designer', color: '#00d4b8' },
  { quote: "Showed this to my whole team. We found three apps on company Macs sending unencrypted data. This paid for itself instantly.", handle: '@ctosomewhere', role: 'Chief Technology Officer', color: '#f5a623' },
  { quote: "I'm not technical at all but this makes sense to me. Plain English, clean design. Exactly what I needed.", handle: '@nontechuser', role: 'School Teacher', color: '#4d9de0' },
  { quote: "The one-time price sealed it for me. Tired of everything being a subscription. Netwoke is refreshing.", handle: '@subhater2024', role: 'Freelance Writer', color: '#00d4b8' },
  { quote: "Works exactly as advertised. No fluff, no upsells, no accounts. Just a great tool that does what it says.", handle: '@honest_review', role: 'Small Business Owner', color: '#3ecf8e' },
]

// ─── Testimonial card ─────────────────────────────────────────────────────────
function TestimonialCard({ quote, handle, role, color }) {
  return (
    <div className="testimonial-card" style={{
      flexShrink: 0,
      width: 260,
      background: 'var(--elevated)',
      border: '1px solid var(--border)',
      borderRadius: 14, padding: '16px 16px 12px',
      display: 'flex', flexDirection: 'column', gap: 12,
      cursor: 'default',
      transition: 'border-color 0.2s, transform 0.2s',
    }}
      onMouseEnter={e => { e.currentTarget.style.borderColor = color + '60'; e.currentTarget.style.transform = 'translateY(-2px)' }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.transform = 'translateY(0)' }}
    >
      {/* Quote */}
      <p className="testimonial-quote" style={{
        fontSize: 13, color: 'rgba(220,232,245,0.8)',
        lineHeight: 1.7, fontWeight: 300, margin: 0,
        fontFamily: 'var(--font-body)', flex: 1,
      }}>
        "{quote}"
      </p>

      {/* Author */}
      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
        <div className="testimonial-avatar" style={{
          width: 32, height: 32, borderRadius: '50%', flexShrink: 0,
          background: `${color}18`, border: `1px solid ${color}35`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 12, fontWeight: 700, color,
          fontFamily: 'var(--font-mono)',
        }}>
          {handle.replace('@','').charAt(0).toUpperCase()}
        </div>
        <div>
          <div className="testimonial-handle" style={{ fontSize:11, fontWeight:600, color, fontFamily:'var(--font-mono)' }}>{handle}</div>
          <div className="testimonial-role" style={{ fontSize:10, color:'var(--faint)', fontFamily:'var(--font-mono)' }}>{role}</div>
        </div>
      </div>
    </div>
  )
}

// ─── Hamburger menu ───────────────────────────────────────────────────────────
function MobileMenu({ open, onClose, navigate }) {
  const links = [
    { label: 'Features', id: 'features' },
    { label: 'How It Works', id: 'how' },
    { label: 'Ollama', id: 'ollama' },
    { label: 'Privacy', id: 'privacy' },
    { label: 'Why Netwoke?', href: '/why-netwoke', isRoute: true },
  ]
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [open])

  if (!open) return null
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 200, display: 'flex', flexDirection: 'column' }}>
      {/* backdrop */}
      <div onClick={onClose} style={{ position: 'absolute', inset: 0, background: 'rgba(4,6,13,0.7)', backdropFilter: 'blur(8px)' }} />
      {/* drawer */}
      <div style={{ position: 'relative', zIndex: 1, background: 'var(--surface)',
        padding: '20px 24px 32px', display: 'flex', flexDirection: 'column', gap: 4 }}>
        {/* top row */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <div style={{ width: 50, height: 50, borderRadius: 12, overflow: 'hidden' }}>
              <img src={nLogo} alt="N" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <div style={{ width: 140, height: 140, borderRadius: 32, overflow: 'hidden' }}>
              <img src="/newlogo.png" alt="Netwoke" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}>{I.close}</button>
        </div>
        {links.map((link) => (
          <button key={link.id || link.label} onClick={() => {
            onClose()
            if (link.isRoute) {
              navigate(link.href)
            } else {
              setTimeout(() => scrollTo(link.id), 100)
            }
          }}
            style={{ background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left',
              padding: '14px 0', fontSize: 18, fontWeight: 500, color: 'var(--text)',
              borderBottom: '1px solid var(--border)', fontFamily: 'var(--font-body)',
              letterSpacing: '-0.01em' }}>
            {link.label}
          </button>
        ))}
        <button onClick={() => { onClose(); navigate('/demo') }} className="mobile-demo-button"
          style={{ marginTop: 20, padding: '16px', background: 'var(--accent-amber)', color: '#04060d',
            border: 'none', borderRadius: 10, fontSize: 16, fontWeight: 700, cursor: 'pointer',
            fontFamily: 'var(--font-body)', letterSpacing: '0.01em' }}>
          View Demo
        </button>
      </div>
    </div>
  )
}

// ─── MAIN ─────────────────────────────────────────────────────────────────────
export default function LandingPage() {
  const navigate = useNavigate()
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const [isDownloading, setIsDownloading] = useState(false)
  useReveal()

  const handleDownload = () => {
    if (isDownloading) return // Prevent multiple clicks
    
    setIsDownloading(true)
    
    // Small delay to ensure UI updates before download starts
    setTimeout(() => {
      // Simple direct download link approach
      const link = document.createElement('a')
      link.href = 'https://buy.stripe.com/eVq7sM6Mi3uwfc8elh04803'
      link.download = 'Netwoke-1.0.0-arm64.dmg'
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }, 100)
    
    // Reset after 3 seconds (enough time for download to start)
    setTimeout(() => {
      setIsDownloading(false)
    }, 3000)
  }

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40)
    window.addEventListener('scroll', fn)
    return () => window.removeEventListener('scroll', fn)
  }, [])

  const navScroll = useCallback((id) => { setMenuOpen(false); scrollTo(id) }, [])

  return (
    <>
      <style>{`
        :root {
          --black:#04060d;--deep:#080c16;--surface:#0d1220;--elevated:#121a2e;
          --border:rgba(255,255,255,0.07);--border2:rgba(255,255,255,0.12);
          --teal:#00d4b8;--blue:#4d9de0;--green:#3ecf8e;--amber:#f5a623;--red:#ef4444;
          --text:#dce8f5;--muted:rgba(220,232,245,0.5);--faint:rgba(220,232,245,0.25);
          --font-display:'IBM Plex Sans',sans-serif;
          --font-mono:'IBM Plex Mono',monospace;
          --font-body:'IBM Plex Sans',sans-serif;
        }
        .nw-root{background:var(--black);color:var(--text);font-family:var(--font-body);
          -webkit-font-smoothing:antialiased;min-height:100vh;
          overflow-x:hidden; overflow-y:auto;}
        .nw-root *{box-sizing:border-box;margin:0;padding:0;}
        .nw-page{position:relative;z-index:2;}
        .grad{background:linear-gradient(135deg,var(--teal) 0%,var(--blue) 60%);
          -webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
        .nw-reveal{opacity:0;transform:translateY(22px);transition:opacity .6s ease,transform .6s ease;}
        .nw-visible{opacity:1;transform:none;}
        @keyframes nw-scroll-left  { from { transform: translateX(0) } to { transform: translateX(-50%) } }
        @keyframes nw-scroll-right { from { transform: translateX(-50%) } to { transform: translateX(0) } }
        @keyframes nw-pulse{0%,100%{opacity:1;box-shadow:0 0 8px var(--teal)}50%{opacity:.4;box-shadow:0 0 3px var(--teal)}}
        @keyframes lp-shake{0%,100%{transform:translateX(0)}20%{transform:translateX(-8px)}40%{transform:translateX(8px)}60%{transform:translateX(-5px)}80%{transform:translateX(5px)}}
        @keyframes lp-slidedown{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:translateY(0)}}
        @keyframes lp-fadein{from{opacity:0}to{opacity:1}}
        @keyframes lp-spin{to{transform:rotate(360deg)}}
        @keyframes nw-scroll-left {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes nw-scroll-right {
          0%   { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
        @keyframes nw-float{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}
        .nw-float{animation:nw-float 7s ease-in-out infinite;}
        .td-r{background:#ff5f57}.td-y{background:#ffbd2e}.td-g{background:#28ca41}
        .ollama-mascot{position:relative;width:48px;height:48px;display:inline-flex;
          align-items:center;justify-content:center;transition:transform .24s ease;transform-origin:50% 58%;}
        .ollama-card:hover .ollama-mascot,.ollama-mascot:hover{transform:translateY(-2px) rotate(-2deg) scale(1.07);}
        .ollama-mascot-img{width:48px;height:48px;object-fit:contain;display:block;}
        .ollama-face{position:absolute;inset:0;width:48px;height:48px;overflow:visible;pointer-events:none;}
        .ollama-wink-cover{fill:#fff;opacity:0;transition:opacity .08s ease;}
        .ollama-wink-line{fill:none;stroke:#000;stroke-width:2.8;stroke-linecap:round;
          opacity:0;transform-origin:32.4px 22.2px;}
        .ollama-smile{fill:none;stroke:#000;stroke-width:2.6;stroke-linecap:round;
          opacity:0;stroke-dasharray:14;stroke-dashoffset:14;transition:opacity .12s ease,stroke-dashoffset .28s ease;}
        .ollama-card:hover .ollama-wink-cover,.ollama-mascot:hover .ollama-wink-cover{opacity:1;animation:ollama-wink-cover .9s ease-in-out both;}
        .ollama-card:hover .ollama-wink-line,.ollama-mascot:hover .ollama-wink-line{opacity:1;animation:ollama-wink-line .9s ease-in-out both;}
        .ollama-card:hover .ollama-smile,.ollama-mascot:hover .ollama-smile{opacity:1;stroke-dashoffset:0;}
        @keyframes ollama-wink-cover{0%,100%{transform:scaleY(0);opacity:0;}26%,72%{transform:scaleY(1);opacity:1;}}
        @keyframes ollama-wink-line{0%,100%{transform:scaleY(.2);opacity:0;}26%,72%{transform:scaleY(1);opacity:1;}}

        /* layout helpers */
        .feat-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:14px;}
        .priv-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-top:48px;}
        .stats-row{display:flex;border:1px solid var(--border);border-radius:12px;
          overflow:hidden;background:var(--surface);max-width:780px;width:100%;}
        .stat-cell{flex:1;padding:28px 20px;text-align:center;border-right:1px solid var(--border);}
        .stat-cell:last-child{border-right:none;}
        .trust-row{margin-top:48px;display:flex;gap:40px;justify-content:center;flex-wrap:wrap;}
        .steps-wrap{position:relative;margin-top:48px;}
        .steps-wrap::before{content:'';position:absolute;left:21px;top:44px;bottom:44px;
          width:1px;background:linear-gradient(to bottom,var(--teal),var(--blue),transparent);opacity:.22;}

        /* hamburger button */
        .hbg{display:none;background:none;border:none;cursor:pointer;padding:8px;
          border-radius:8px;align-items:center;justify-content:center;}

        /* ── Tablet ── */
        @media(max-width:900px){
          .feat-grid{grid-template-columns:repeat(2,1fr);}
          .priv-grid{grid-template-columns:1fr;}
          .testimonial-grid{grid-template-columns:1fr !important;}
          .stats-row{flex-wrap:wrap;}
          .stat-cell{flex:1 1 45%;border-right:none;border-bottom:1px solid var(--border);}
          .stat-cell:last-child{border-bottom:none;}
        }

        /* ── Mobile ── */
        @media(max-width:640px){
          .hbg{display:flex;}
          .nav-links{display:none !important;}
          .demo-button-desktop{display:none !important;}
          .mobile-demo-button{display:none !important;}
          .nw-nav{padding:0 16px !important;height:56px !important;}
          .nw-hero{padding:88px 16px 52px !important;}
          .hero-btns{flex-direction:column;align-items:stretch !important;}
          .hero-btns button{justify-content:center !important;}
          .nw-preview{padding:0 8px !important;}
          .feat-grid{grid-template-columns:1fr;gap:10px;}
          .priv-grid{grid-template-columns:1fr;gap:10px;}
          .stats-row{flex-direction:column;border-radius:10px;}
          .stat-cell{width:100%;border-right:none;border-bottom:1px solid var(--border);padding:20px 16px;}
          .stat-cell:last-child{border-bottom:none;}
          .nw-section{padding:56px 16px !important;}
          .nw-steps{padding:56px 16px !important;}
          .nw-priv{padding:48px 16px !important;}
          .nw-cta{padding:64px 16px !important;}
          .cta-dl-btn{width:100% !important;max-width:340px !important;justify-content:center !important;}
          .trust-row{gap:20px;}
          .nw-footer{padding:24px 16px !important;flex-direction:column !important;align-items:center !important;gap:16px !important;}
          .nw-footer-links{flex-wrap:wrap;gap:14px !important;}
          .section-label-center{text-align:left !important;}
          .section-title-center{text-align:left !important;}
          .section-sub-center{text-align:left !important;margin-left:0 !important;}
          .steps-wrap::before{display:none;}
          .preview-speed-row{grid-template-columns:1fr !important;}
          .preview-speed-border{border-right:none !important;border-bottom:1px solid var(--border) !important;}
          /* Mobile hero preview optimizations */
          .preview-metrics{display:none !important;}
          .preview-tabs{gap:3px !important;padding:7px 8px !important;}
          .preview-tabs > div{padding:5px 7px !important;gap:4px !important;}
          .preview-tabs .preview-tab-label{display:inline !important;font-size:9px !important;}
          .preview-search{display:none !important;}
          .preview-mac-label{display:none !important;}
          .preview-title-bar{padding:9px 12px !important;}
          .preview-speed-val{font-size:15px !important;}
          .preview-conn-name{font-size:9px !important;}
          .preview-conn-detail{display:none !important;}
          .preview-detail-grid{grid-template-columns:repeat(2,1fr) !important;}
          .preview-ai-text{font-size:9px !important;}
          .preview-modal{padding:12px 14px !important;}
          .preview-modal-title{font-size:11px !important;}
          .preview-modal-body{font-size:9px !important;}
          /* Testimonial mobile optimization */
          .testimonial-section{padding: 64px 16px !important; max-width: 100% !important;}
          .testimonial-header{margin-bottom: 32px !important; padding: 0 16px !important;}
          .testimonial-title{font-size: clamp(20px,5vw,28px) !important;}
          .testimonial-row{margin-bottom: 12px !important;}
          .testimonial-card{width: 280px !important; padding: 14px 14px 10px !important; gap: 10px !important;}
          .testimonial-quote{font-size: 12px !important; line-height: 1.6 !important;}
          .testimonial-avatar{width: 28px !important; height: 28px !important; font-size: 11px !important;}
          .testimonial-handle{font-size: 10px !important;}
          .testimonial-role{font-size: 9px !important;}
        }
        @media(max-width:380px){
          .nw-hero-title{font-size:30px !important;}
          .nw-cta-title{font-size:26px !important;}
          .stat-num{font-size:26px !important;}
          /* Extra small mobile testimonial optimization */
          .testimonial-card{width: 260px !important; padding: 12px 12px 8px !important;}
          .testimonial-quote{font-size: 11px !important;}
        }
      `}</style>

      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@300;400;500;600&family=IBM+Plex+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

      <SEOHead 
        title="Network Monitoring for Mac - Monitor Your Connections in Real-Time"
        description="Spot suspicious activity and monitor your Mac's network connections with Netwoke. Real-time network monitoring, privacy protection, and security insights for macOS."
        canonicalUrl="https://netwoke.app"
        schemaData={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": "Netwoke",
          "description": "Monitor your Mac's network connections in real-time. Spot suspicious activity, see which apps are connecting where, and protect your privacy.",
          "url": "https://netwoke.app",
          "applicationCategory": "SecurityApplication",
          "operatingSystem": "macOS",
          "offers": {
            "@type": "Offer",
            "price": "29",
            "priceCurrency": "USD",
            "validFrom": "2024-01-01",
            "availability": "https://schema.org/InStock"
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "127",
            "bestRating": "5",
            "worstRating": "1"
          },
          "author": {
            "@type": "Organization",
            "name": "Netwoke",
            "url": "https://netwoke.app"
          },
          "publisher": {
            "@type": "Organization",
            "name": "Netwoke",
            "url": "https://netwoke.app"
          },
          "featureList": [
            "Real-time network monitoring",
            "Connection tracking and analysis",
            "Privacy protection tools",
            "macOS integration",
            "AI-powered explanations"
          ],
          "screenshot": "https://netwoke.app/newlogo.png",
          "downloadUrl": "https://netwoke.app/download",
          "softwareVersion": "1.0.2",
          "datePublished": "2024-01-01",
          "dateModified": "2024-12-01"
        }}
      />

      <div className="nw-root">
        <ParticleCanvas />
        <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} navigate={navigate} />

        <div className="nw-page">

          {/* ── NAV ── */}
          <nav className="nw-nav" style={{
            position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
            height: 50, padding: '0 48px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            background: 'var(--black)',
            backdropFilter: 'blur(12px)',
          }}>
            {/* Logo */}
            <div onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              style={{ display: 'flex', alignItems: 'center', gap: 5, cursor: 'pointer' }}>
              <div style={{ width: 40, height: 40, borderRadius: 8, overflow: 'hidden' }}>
                <img src={nLogo} alt="N" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <div style={{ width: 130, height: 130, borderRadius: 20, overflow: 'hidden' }}>
                <img src="/newlogo.png" alt="Netwoke - Network Monitoring for Mac" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
            </div>

            {/* Desktop links */}
            <ul className="nav-links" style={{ display: 'flex', alignItems: 'center', gap: 32, listStyle: 'none' }}>
              {[['Features','features'],['How It Works','how'],['Ollama','ollama'],['Privacy','privacy']].map(([l,id]) => (
                <li key={id}>
                  <span onClick={() => navScroll(id)} style={{ fontSize: 13, color: 'var(--muted)',
                    cursor: 'pointer', letterSpacing: '0.02em', transition: 'color .15s' }}
                    onMouseEnter={e => e.target.style.color='var(--text)'}
                    onMouseLeave={e => e.target.style.color='var(--muted)'}>{l}</span>
                </li>
              ))}
              <li>
                <span onClick={() => navigate('/why-netwoke')} style={{
                  fontSize: 13, color: 'var(--muted)', cursor: 'pointer',
                  transition: 'color 0.15s', fontFamily: 'var(--font-body)',
                }}
                  onMouseEnter={e => e.target.style.color = 'var(--text)'}
                  onMouseLeave={e => e.target.style.color = 'var(--muted)'}
                >
                  Why Netwoke?
                </span>
              </li>
              <li className="demo-button-desktop">
                <button onClick={() => navigate('/demo')}
                  style={{ padding: '8px 20px', background: 'var(--accent-amber)', color: '#04060d',
                    border: 'none', borderRadius: 6, fontWeight: 600, fontSize: 13,
                    cursor: 'pointer', fontFamily: 'var(--font-body)', transition: 'all 0.2s' }}
                  onMouseEnter={e => { e.currentTarget.style.transform='translateY(-1px)'; e.currentTarget.style.boxShadow='0 4px 12px rgba(245,166,35,0.4), 0 0 20px rgba(245,166,35,0.2)' }}
                  onMouseLeave={e => { e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='none' }}>
                  View Demo
                </button>
              </li>
            </ul>

            {/* Hamburger */}
            <button className="hbg" onClick={() => setMenuOpen(true)}>{I.menu}</button>
          </nav>

          {/* ── HERO ── */}
          <section className="nw-hero" role="main" aria-labelledby="hero-heading" style={{
            minHeight: '100vh', display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
            textAlign: 'center', padding: '160px 24px 80px',
          }}>
            {/* Badge */}
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '8px 16px',
              border: '1px solid rgba(0,212,184,0.5)', borderRadius: 20, background: 'rgba(0,212,184,0.1)',
              fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--teal)',
              letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 8, fontWeight: 500 }}>
              macOS · One Time Purchase · No Account Needed
            </div>

            <h1 id="hero-heading" className="nw-hero-title" style={{ fontFamily: 'var(--font-display)',
              fontSize: 'clamp(36px,6.5vw,80px)', fontWeight: 700, lineHeight: 1.08,
              letterSpacing: '-0.025em', maxWidth: 840, marginBottom: 24 }}>
              Spot Suspicious Activity.<br /><span className="grad">Monitor your Mac Online.</span>
            </h1>

            <p style={{ fontSize: 'clamp(12px,1.4vw,15px)', color: 'var(--muted)', maxWidth: 520,
              lineHeight: 1.75, marginBottom: 44, fontWeight: 300 }}>
              Your network has secrets. Now you can see them. No packet jargon — just clear,
              plain-English answers about which apps are connecting, where, and whether your data is safe.
            </p>

            <div className="hero-btns" style={{ display: 'flex', gap: 12, alignItems: 'center',
              flexWrap: 'wrap', justifyContent: 'center', marginBottom: 16 }}>
              <button onClick={handleDownload}
                disabled={isDownloading}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 10, padding: '14px 28px',
                  background: isDownloading ? 'var(--amber)' : 'var(--teal)', color: '#04060d', borderRadius: 8, fontWeight: 600,
                  fontSize: 14, border: 'none', cursor: isDownloading ? 'not-allowed' : 'pointer', fontFamily: 'var(--font-body)',
                  boxShadow: '0 0 40px rgba(0,212,184,0.2)', transition: 'all .2s', opacity: isDownloading ? 0.7 : 1 }}
                onMouseEnter={e => { if (!isDownloading) { e.currentTarget.style.transform='translateY(-2px)'; e.currentTarget.style.boxShadow='0 0 60px rgba(0,212,184,0.38)' } }}
                onMouseLeave={e => { if (!isDownloading) { e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='0 0 40px rgba(0,212,184,0.2)' } }}>
                {isDownloading ? 'Processing...' : <>{I.dl}&nbsp;Download for macOS</>}
              </button>
              <button onClick={() => navScroll('features')}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '14px 24px',
                  border: '1px solid var(--border2)', color: 'var(--muted)', borderRadius: 8,
                  fontSize: 14, background: 'none', cursor: 'pointer', fontFamily: 'var(--font-body)',
                  transition: 'all .2s' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor='rgba(255,255,255,0.25)'; e.currentTarget.style.color='var(--text)' }}
                onMouseLeave={e => { e.currentTarget.style.borderColor='var(--border2)'; e.currentTarget.style.color='var(--muted)' }}>
                See how it works &nbsp;{I.chevR}
              </button>
            </div>

            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--faint)',
              letterSpacing: '0.06em', marginBottom: 64 }}>
              macOS 12 Monterey or later &nbsp;·&nbsp; Apple Silicon &amp; Intel &nbsp;·&nbsp; No account required
            </div>

            {/* App window preview */}
            <div className="nw-preview nw-float" style={{ width: '100%', maxWidth: 900, padding: '0 20px', position: 'relative' }}>
              <div style={{ position: 'absolute', top: '50%', left: '50%',
                transform: 'translate(-50%,-50%)', width: '80%', height: '60%',
                background: 'radial-gradient(ellipse,rgba(0,212,184,0.09) 0%,transparent 70%)',
                pointerEvents: 'none' }} />
              <div style={{ background: '#0a0f1a', border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: 14, overflow: 'hidden',
                boxShadow: '0 40px 120px rgba(0,0,0,0.85),0 0 0 1px rgba(255,255,255,0.05),inset 0 1px 0 rgba(255,255,255,0.06)' }}>

                {/* ── TITLE BAR ── */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '13px 18px',
                  background: 'rgba(0,0,0,0.4)', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
                  {/* Traffic lights */}
                  <div style={{ display: 'flex', gap: 6, marginRight: 8 }}>
                    <div style={{ width: 12, height: 12, borderRadius: '50%', background: '#ff5f57' }} />
                    <div style={{ width: 12, height: 12, borderRadius: '50%', background: '#ffbd2e' }} />
                    <div style={{ width: 12, height: 12, borderRadius: '50%', background: '#28ca41' }} />
                  </div>
                                    <div style={{ flex: 1 }} />
                  {/* Live indicator */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 5,
                    fontFamily: 'var(--font-mono)', fontSize: 9, color: 'var(--teal)' }}>
                    <Dot />LIVE
                  </div>
                </div>

                {/* ── SPEED PANEL ── */}
                <div className="preview-speed-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr',
                  borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
                  {[
                    ['↓ DOWNLOAD', 'var(--blue)', true, 'dl'],
                    ['↑ UPLOAD', 'var(--red)', false, 'ul']
                  ].map(([l, c, br, k]) => (
                    <div key={l} className={br ? 'preview-speed-border' : ''} style={{ padding: '12px 18px',
                      borderRight: br ? '1px solid rgba(255,255,255,0.07)' : 'none' }}>
                      <div style={{ fontFamily: 'var(--font-mono)', fontSize: 8, color: 'rgba(220,232,245,0.35)',
                        textTransform: 'uppercase', letterSpacing: '0.14em', marginBottom: 4 }}>{l}</div>
                      <div className="preview-speed-val" style={{ fontFamily: 'var(--font-mono)', fontSize: 20, fontWeight: 500,
                        color: c, letterSpacing: '-0.02em', marginBottom: 6 }}>
                        <AnimSpeed type={k} />
                      </div>
                    </div>
                  ))}
                  {/* Single dual-wave component spanning both columns */}
                  <div style={{ gridColumn: '1 / -1', padding: '0 18px 12px' }}>
                    <SpeedWave type="dl" />
                  </div>
                </div>

                {/* ── METRICS BAR ── */}
                <div className="preview-metrics" style={{ display: 'flex', alignItems: 'center', gap: 20, padding: '9px 18px',
                  borderBottom: '1px solid rgba(255,255,255,0.07)', background: 'rgba(0,0,0,0.2)' }}>
                  {[
                    { label: 'CPU', pct: 28, color: '#00d4b8', sub: '10-core · load 2.82' },
                    { label: 'MEMORY', pct: 72, color: '#f5a623', sub: '12.4 GB of 17.2 GB · 72% used' },
                  ].map(({ label, pct, color, sub }) => (
                    <div key={label} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <PreviewRing pct={pct} color={color} />
                      <div>
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
                          <span style={{ fontSize: 9, color: 'rgba(220,232,245,0.4)',
                            fontFamily: 'var(--font-mono)', letterSpacing: '0.08em' }}>{label}</span>
                          <span style={{ fontSize: 13, fontWeight: 700, color,
                            fontFamily: 'var(--font-mono)' }}>{pct}%</span>
                        </div>
                        <div style={{ fontSize: 8, color: 'rgba(220,232,245,0.3)',
                          fontFamily: 'var(--font-mono)' }}>{sub}</div>
                      </div>
                    </div>
                  ))}
                  <div className="preview-mac-label" style={{ marginLeft: 'auto', fontSize: 9, color: 'rgba(220,232,245,0.25)',
                    fontFamily: 'var(--font-mono)' }}>Apple M1 Pro</div>
                </div>

                {/* ── TAB BAR ── */}
                <div className="preview-tabs" style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '8px 14px',
                  borderBottom: '1px solid rgba(255,255,255,0.07)', background: 'rgba(0,0,0,0.15)' }}>
                  {[
                    { label: 'Connections', count: 22, active: true },
                    { label: 'Apps', count: 4, active: false },
                    { label: 'Alerts', count: 3, active: false, warn: true },
                  ].map(t => (
                    <div key={t.label} style={{
                      display: 'flex', alignItems: 'center', gap: 5,
                      padding: '5px 10px', borderRadius: 7,
                      background: t.active ? 'rgba(77,157,224,0.12)' : 'transparent',
                      border: t.active ? '1px solid rgba(245,166,35,0.5)' : '1px solid transparent',
                    }}>
                      <span className="preview-tab-label" style={{ fontSize: 10, color: t.active ? '#dce8f5' : 'rgba(220,232,245,0.4)',
                        fontFamily: 'var(--font-body)', fontWeight: t.active ? 600 : 400 }}>{t.label}</span>
                      <span style={{ fontSize: 8, padding: '1px 5px', borderRadius: 4,
                        background: t.warn ? 'rgba(245,166,35,0.2)' : 'rgba(255,255,255,0.07)',
                        color: t.warn ? '#f5a623' : 'rgba(220,232,245,0.4)',
                        fontFamily: 'var(--font-mono)' }}>{t.count}</span>
                    </div>
                  ))}
                  <div className="preview-search" style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 6,
                    padding: '5px 10px', borderRadius: 7,
                    background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)' }}>
                    <span style={{ fontSize: 9, color: 'rgba(220,232,245,0.25)' }}>🔍</span>
                    <span style={{ fontSize: 9, color: 'rgba(220,232,245,0.25)',
                      fontFamily: 'var(--font-mono)' }}>Search apps, domains...</span>
                  </div>
                </div>

                {/* ── CONNECTIONS ── */}
                <AnimConnections />
              </div>
            </div>

          </section>

          {/* ── FEATURES ── */}
          <section id="features" className="nw-section" style={{ padding: '88px 24px', maxWidth: 1080, margin: '0 auto' }}>
            <div className="nw-reveal section-label-center" style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--teal)', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 12, textAlign: 'center' }}>What you get</div>
            <h2 className="nw-reveal section-title-center" style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(24px,3.5vw,42px)', fontWeight: 700, textAlign: 'center', lineHeight: 1.15, marginBottom: 12, letterSpacing: '-0.025em' }}>Everything you need to<br />understand — and control — your network</h2>
            <p className="nw-reveal section-sub-center" style={{ fontSize: 16, color: 'var(--muted)', textAlign: 'center', maxWidth: 500, margin: '0 auto 56px', lineHeight: 1.75, fontWeight: 300 }}>No degree required. Netwoke turns raw network data into plain English anyone can act on.</p>
            <div className="feat-grid">
              <FCard icon={I.wave}    iconBg="rgba(77,157,224,0.1)"  title="Live Speed"               desc="Animated upload &amp; download charts. Instantly see if something's hogging your connection." />
              <FCard icon={I.ai}      iconBg="rgba(0,212,184,0.1)"   title="Ai Explaines it"          desc="Every connection in plain English — Netwoke automaticaly connects to your local ollama model. Everything stays local and private." />
              <FCard icon={I.monitor} iconBg="rgba(62,207,142,0.1)"  title="Per-App Usage"            desc="See exactly which apps are on the internet and where they're sending your data." />
              <FCard icon={I.map}     iconBg="rgba(245,166,35,0.1)"  title="Countries &amp; Domains"  desc="Destination country and domain name shown clearly for every connection." />
              <FCard icon={I.lock}    iconBg="rgba(0,212,184,0.1)"   title="Encryption Status"        desc="See which connections are encrypted and which are sending data in the open." />
              <FCard icon={I.bell}    iconBg="rgba(239,68,68,0.1)"   title="Smart Alerts"             desc="Flags unusual ports, unexpected countries, unencrypted traffic, and background uploads." />
              <FCard icon={I.chip}    iconBg="rgba(77,157,224,0.1)"  title="CPU &amp; Memory"         desc="Live system health so you know if your Mac is being pushed while data transfers." />
              <FCard icon={I.clock}   iconBg="rgba(62,207,142,0.1)"  title="Connection Details"       desc="Remote IP, port, protocol, country, domain, and process ID when you expand a card." />
              <FCard icon={I.search}  iconBg="rgba(0,212,184,0.1)"   title="Search &amp; Filter"      desc="Type any app, domain, or country to instantly filter all active connections." />
              <FCard icon={I.power}   iconBg="rgba(239,68,68,0.1)"   title="Kill Process"             desc="Terminate any app making a suspicious connection instantly — one click, confirmed with a prompt." />
              <FCard icon={I.shield2} iconBg="rgba(245,166,35,0.1)"  title="Block IP"                 desc="Add a macOS firewall rule to drop all traffic to a remote IP directly from the connection card." />
              <FCard icon={I.menubar} iconBg="rgba(0,212,184,0.1)"   title="Menu Bar Mode"            desc="Lives quietly in your menu bar showing live speeds. Click for a popover with all active connections." />
            </div>
          </section>

          {/* ── TESTIMONIALS ── */}
          <section className="testimonial-section" style={{ padding: '88px 24px', maxWidth: 720, margin: '0 auto', overflow: 'hidden' }}>
            {/* Header */}
            <div className="testimonial-header nw-reveal" style={{ textAlign:'center', marginBottom:48 }}>
              <div style={{ fontFamily:'var(--font-mono)', fontSize:11, color:'var(--teal)', letterSpacing:'0.14em', textTransform:'uppercase', marginBottom:10 }}>
                Early users
              </div>
              <h2 className="testimonial-title" style={{ fontFamily:'var(--font-display)', fontSize:'clamp(24px,3.5vw,38px)', fontWeight:700, lineHeight:1.1, letterSpacing:'-0.025em', margin:0 }}>
                What people are saying
              </h2>
            </div>

            {/* Row 1 — scrolls left */}
            <div className="testimonial-row" style={{ position:'relative', marginBottom:16 }}>
              <div style={{ position: 'relative' }}>
                {/* Left fade */}
                <div style={{
                  position: 'absolute', left: 0, top: 0, bottom: 0, width: 160, zIndex: 2,
                  WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 40%, black 60%, transparent 100%)',
                  maskImage: 'linear-gradient(to right, transparent 0%, black 40%, black 60%, transparent 100%)',
                  background: 'linear-gradient(to right, var(--bg-page), transparent)',
                  pointerEvents: 'none',
                }} />
                {/* Right fade */}
                <div style={{
                  position: 'absolute', right: 0, top: 0, bottom: 0, width: 160, zIndex: 2,
                  WebkitMaskImage: 'linear-gradient(to left, transparent 0%, black 40%, black 60%, transparent 100%)',
                  maskImage: 'linear-gradient(to left, transparent 0%, black 40%, black 60%, transparent 100%)',
                  background: 'linear-gradient(to left, var(--bg-page), transparent)',
                  pointerEvents: 'none',
                }} />
                
                <div style={{ display:'flex', gap:16, animation:'nw-scroll-left 12s linear infinite' }}
                  onMouseEnter={e => e.currentTarget.style.animationPlayState='paused'}
                  onMouseLeave={e => e.currentTarget.style.animationPlayState='running'}
                >
                  {[...ROW1, ...ROW1].map((t, i) => <TestimonialCard key={i} {...t} />)}
                </div>
              </div>
            </div>

            {/* Row 2 — scrolls right */}
            <div className="testimonial-row" style={{ position:'relative' }}>
              <div style={{ position: 'relative' }}>
                {/* Left fade */}
                <div style={{
                  position: 'absolute', left: 0, top: 0, bottom: 0, width: 160, zIndex: 2,
                  WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 40%, black 60%, transparent 100%)',
                  maskImage: 'linear-gradient(to right, transparent 0%, black 40%, black 60%, transparent 100%)',
                  background: 'linear-gradient(to right, var(--bg-page), transparent)',
                  pointerEvents: 'none',
                }} />
                {/* Right fade */}
                <div style={{
                  position: 'absolute', right: 0, top: 0, bottom: 0, width: 160, zIndex: 2,
                  WebkitMaskImage: 'linear-gradient(to left, transparent 0%, black 40%, black 60%, transparent 100%)',
                  maskImage: 'linear-gradient(to left, transparent 0%, black 40%, black 60%, transparent 100%)',
                  background: 'linear-gradient(to left, var(--bg-page), transparent)',
                  pointerEvents: 'none',
                }} />
                
                <div style={{ display:'flex', gap:16, animation:'nw-scroll-right 14s linear infinite' }}
                  onMouseEnter={e => e.currentTarget.style.animationPlayState='paused'}
                  onMouseLeave={e => e.currentTarget.style.animationPlayState='running'}
                >
                  {[...ROW2, ...ROW2].map((t, i) => <TestimonialCard key={i} {...t} />)}
                </div>
              </div>
            </div>
          </section>

          {/* ── HOW IT WORKS ── */}
          <section id="how" className="nw-steps" style={{ padding: '88px 24px', maxWidth: 800, margin: '0 auto' }}>
            <div className="nw-reveal" style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--teal)', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 12 }}>How it works</div>
            <h2 className="nw-reveal" style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(24px,3.5vw,42px)', fontWeight: 700, lineHeight: 1.15, marginBottom: 0, letterSpacing: '-0.025em', maxWidth: 440 }}>Up and running<br />in under a minute</h2>
            <div className="steps-wrap">
              <Step num="01" title="Download & Install" desc="Download the DMG, drag Netwoke to Applications, and open it. No account, no email, no subscription." />
              <Step num="02" title="Grant Network Access" desc="macOS asks permission to monitor connections. It's the only permission needed — all data stays on your device." />
              <Step num="03" title="See Everything, Instantly" desc="The dashboard fills with live data immediately — every connection, which app, and where it connects."
                code={`🔒 Chrome securely connected to google.com\n    🇺🇸 United States\n\n🔒 Spotify securely connected to spotify.com\n    🇸🇪 Sweden\n\n⚠️ Safari connected to tehran-media.ir\n    🇮🇷 Iran`} />
              <Step num="04" title="Get Alerted to Anything Unusual" desc="Netwoke watches for unusual ports, unexpected countries, unencrypted traffic, and silent background uploads." />
            </div>
          </section>

          {/* ── PRIVACY ── */}
          <section id="privacy" className="nw-priv" style={{ padding: '72px 24px', maxWidth: 1080, margin: '0 auto' }}>
            <div className="nw-reveal section-label-center" style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--teal)', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 12, textAlign: 'center' }}>Built for privacy</div>
            <h2 className="nw-reveal section-title-center" style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(24px,3.5vw,42px)', fontWeight: 700, textAlign: 'center', lineHeight: 1.15, marginBottom: 12, letterSpacing: '-0.025em' }}>Your data never leaves<br />your machine</h2>
            <p className="nw-reveal section-sub-center" style={{ fontSize: 16, color: 'var(--muted)', textAlign: 'center', maxWidth: 480, margin: '0 auto', lineHeight: 1.75, fontWeight: 300 }}>Netwoke was built with a simple rule: a privacy tool should itself be private.</p>
            <div className="priv-grid">
              <PCard icon={I.home}   iconBg="rgba(0,212,184,0.1)"  title="100% Local Processing"    desc="Everything runs on your Mac. No server, no cloud, no API. Your network data never leaves your device." />
              <PCard icon={I.slash}  iconBg="rgba(239,68,68,0.08)" title="No Account Required"      desc="No signup, no email, no subscription. We don't know you exist — and that's intentional." />
              <PCard icon={I.inbox}  iconBg="rgba(77,157,224,0.1)" title="No Telemetry"             desc="Zero usage data collected. No crash reports, no analytics. The app never phones home." />
              <PCard icon={I.forever} iconBg="rgba(62,207,142,0.1)" title="Own It Forever"              desc="Pay once, own it forever. No monthly fees, no license keys, no account required." />
              <PCard icon={I.eye}    iconBg="rgba(0,212,184,0.1)"  title="You're In Control"         desc="Kill suspicious processes and block remote IPs directly from the dashboard — no Terminal required." />
              <PCard icon={I.shield} iconBg="rgba(245,166,35,0.1)" title="Signed &amp; Notarized"   desc="Developer ID signed and notarized by Apple — Gatekeeper verifies it before it ever runs." />
            </div>
          </section>

          {/* ── OLLAMA ── */}
          <section id="ollama" style={{ padding: '88px 24px', maxWidth: 900, margin: '0 auto' }}>
            <div className="nw-reveal" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', marginBottom: 56 }}>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '5px 16px', borderRadius: 20, background: 'rgba(0,212,184,0.08)', border: '1px solid rgba(0,212,184,0.25)', fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--teal)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 20 }}>
                New — Local AI Support
              </div>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(26px,3.5vw,42px)', fontWeight: 700, letterSpacing: '-0.025em', lineHeight: 1.1, marginBottom: 16 }}>
                Run AI explanations{' '}
                <span style={{ background: 'linear-gradient(90deg,var(--teal),var(--blue))', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
                  100% on your Mac
                </span>
              </h2>
              <p style={{ fontSize: 16, color: 'var(--muted)', lineHeight: 1.8, fontWeight: 300, maxWidth: 540 }}>
                Netwoke now automatically detects <strong style={{ color: 'var(--text)' }}>Ollama</strong> — a free, open-source local AI runtime. If Ollama is running on your Mac, Netwoke uses it instead of any cloud service. Your AI explanations never leave your machine. Zero API calls. Zero cost. Forever.
              </p>
            </div>

            {/* Comparison pills */}
            <div className="nw-reveal" style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 56 }}>
              {[
                { label: 'With Ollama', desc: 'Local · Free · Private', color: 'white', border: 'rgba(0,212,184,0.5)', textColor: '#000000', descColor: '#666666' },
              ].map(({ label, desc, color, border, textColor, descColor }, i) => (
                <div key={i} className="ollama-card" style={{ padding: '24px 32px', borderRadius: 16, background: color, border: `2px solid ${border}`, textAlign: 'center', minWidth: 240, transition: 'all 0.3s ease', cursor: 'pointer' }}
                  onMouseEnter={e => { e.currentTarget.style.border='2px solid rgba(0,212,184,0.8)'; e.currentTarget.style.boxShadow='0 0 20px rgba(0,212,184,0.4), 0 0 40px rgba(0,212,184,0.2)'; e.currentTarget.style.transform='translateY(-2px)' }}
                  onMouseLeave={e => { e.currentTarget.style.border=`2px solid ${border}`; e.currentTarget.style.boxShadow='none'; e.currentTarget.style.transform='translateY(0)' }}>
                  <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <OllamaMascot />
                  </div>
                  <div style={{ fontSize: 16, fontWeight: 700, color: textColor, marginBottom: 6 }}>{label}</div>
                  <div style={{ fontSize: 12, color: descColor, fontFamily: 'var(--font-mono)' }}>{desc}</div>
                </div>
              ))}
            </div>

            {/* How to install */}
            <div className="nw-reveal" style={{ background: '#080f1a', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 20, overflow: 'hidden' }}>
              {/* Header */}
              <div style={{ padding: '20px 28px', borderBottom: '1px solid rgba(255,255,255,0.06)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--teal)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 6 }}>Setup guide</div>
                  <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--text)' }}>Get Ollama running in 3 steps</div>
                </div>
                <a href="https://ollama.com" target="_blank" rel="noopener noreferrer" 
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '7px 14px', borderRadius: 8, background: 'rgba(0,212,184,0.1)', border: '1px solid rgba(0,212,184,0.25)', color: 'var(--teal)', fontSize: 12, fontWeight: 600, textDecoration: 'none', fontFamily: 'var(--font-body)', transition: 'all 0.3s ease' }}
                  onMouseEnter={e => { e.currentTarget.style.background='rgba(0,212,184,0.2)'; e.currentTarget.style.borderColor='rgba(0,212,184,0.5)'; e.currentTarget.style.boxShadow='0 0 20px rgba(0,212,184,0.4), 0 0 40px rgba(0,212,184,0.2)'; e.currentTarget.style.transform='translateY(-2px)' }}
                  onMouseLeave={e => { e.currentTarget.style.background='rgba(0,212,184,0.1)'; e.currentTarget.style.borderColor='rgba(0,212,184,0.25)'; e.currentTarget.style.boxShadow='none'; e.currentTarget.style.transform='translateY(0)' }}>
                  ollama.com
                </a>
              </div>

              {/* Steps */}
              {[
                {
                  num: '01',
                  title: 'Download Ollama',
                  desc: 'Visit ollama.com and download the macOS app. It installs in seconds — just drag to Applications.',
                  code: null,
                  note: 'Free · Open source · macOS native',
                },
                {
                  num: '02',
                  title: 'Pull a model',
                  desc: 'Open Terminal and run one command to download a local AI model. We recommend Llama 3 for the best explanations.',
                  code: 'ollama pull llama3',
                  note: 'Takes 2–5 minutes depending on your connection · ~4GB download',
                },
                {
                  num: '03',
                  title: 'Open Netwoke — done',
                  desc: 'Netwoke automatically detects Ollama on startup. Click "Ask AI" on any connection and you\'ll see "AI Explanation · Ollama (llama3)" — fully local, fully private.',
                  code: null,
                  note: 'No configuration needed · Netwoke handles everything automatically',
                },
              ].map(({ num, title, desc, code, note }, i) => (
                <div key={num} style={{ padding: '24px 28px', borderBottom: i < 2 ? '1px solid rgba(255,255,255,0.05)' : 'none', display: 'flex', gap: 20, alignItems: 'flex-start' }}>
                  {/* Step number */}
                  <div style={{ width: 36, height: 36, borderRadius: 10, background: 'rgba(0,212,184,0.1)', border: '1px solid rgba(0,212,184,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontFamily: 'var(--font-mono)', fontSize: 12, fontWeight: 700, color: 'var(--teal)' }}>
                    {num}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--text)', marginBottom: 6 }}>{title}</div>
                    <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.65, marginBottom: code ? 12 : 8 }}>{desc}</div>
                    {code && (
                      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, padding: '8px 14px', borderRadius: 8, background: 'rgba(0,0,0,0.4)', border: '1px solid rgba(255,255,255,0.08)', fontFamily: 'var(--font-mono)', fontSize: 13, color: 'var(--teal)', marginBottom: 8 }}>
                        <span style={{ color: 'rgba(255,255,255,0.2)' }}>$</span> {code}
                      </div>
                    )}
                    <div style={{ fontSize: 11, color: 'var(--faint)', fontFamily: 'var(--font-mono)' }}>{note}</div>
                  </div>
                </div>
              ))}

              {/* Supported models */}
              <div style={{ padding: '20px 28px', background: 'rgba(0,0,0,0.2)', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
                <div style={{ fontSize: 10, fontFamily: 'var(--font-mono)', color: 'var(--faint)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 12 }}>Supported models — Netwoke picks the best one automatically</div>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {[
                    { name: 'llama3.2:3b', note: 'Best quality', recommended: true },
                    { name: 'mistral', note: 'Fast + accurate', recommended: false },
                    { name: 'phi3', note: 'Lightweight', recommended: false },
                    { name: 'gemma', note: 'Google model', recommended: false },
                  ].map(({ name, note, recommended }) => (
                    <div key={name} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '6px 12px', borderRadius: 8, background: recommended ? 'rgba(0,212,184,0.08)' : 'rgba(255,255,255,0.04)', border: `1px solid ${recommended ? 'rgba(0,212,184,0.25)' : 'rgba(255,255,255,0.07)'}` }}>
                      <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: recommended ? 'var(--teal)' : 'var(--muted)', fontWeight: recommended ? 600 : 400 }}>{name}</span>
                      <span style={{ fontSize: 10, color: 'var(--faint)' }}>{note}</span>
                      {recommended && <span style={{ fontSize: 9, padding: '1px 5px', borderRadius: 4, background: 'rgba(0,212,184,0.15)', color: 'var(--teal)', fontFamily: 'var(--font-mono)' }}>recommended</span>}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* ── CTA ── */}
          <section id="download" className="nw-cta" style={{ padding: '100px 24px', textAlign: 'center', position: 'relative' }}>
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)',
              width: 600, height: 300, background: 'radial-gradient(ellipse,rgba(0,212,184,0.07) 0%,transparent 70%)', pointerEvents: 'none' }} />
            <h2 className="nw-reveal nw-cta-title" style={{ fontFamily: 'var(--font-display)',
              fontSize: 'clamp(28px,4.5vw,54px)', fontWeight: 700, lineHeight: 1.1,
              marginBottom: 18, letterSpacing: '-0.025em', position: 'relative' }}>
              Your network has secrets. Now you can see them.<br /><span className="grad">$11.99 One Time Purchase</span>
            </h2>
            <p className="nw-reveal" style={{ fontSize: 16, color: 'var(--muted)', marginBottom: 40,
              fontWeight: 300, position: 'relative' }}>
              No account. No subscription. No catch.
            </p>
            <div className="nw-reveal" style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap', position: 'relative' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <button className="cta-dl-btn"
                  onClick={window.electronAPI ? () => navigate('/dashboard') : handleDownload}
                  disabled={isDownloading}
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 12,
                    padding: '16px 36px', background: isDownloading ? 'var(--amber)' : 'var(--teal)', color: '#04060d',
                    borderRadius: 10, fontWeight: 700, fontSize: 15, border: 'none',
                    cursor: isDownloading ? 'not-allowed' : 'pointer', fontFamily: 'var(--font-body)',
                    boxShadow: '0 0 50px rgba(0,212,184,0.25)', transition: 'all .25s', opacity: isDownloading ? 0.7 : 1 }}
                  onMouseEnter={e => { if (!isDownloading) { e.currentTarget.style.transform='translateY(-3px)'; e.currentTarget.style.boxShadow='0 0 80px rgba(0,212,184,0.45)' } }}
                  onMouseLeave={e => { if (!isDownloading) { e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='0 0 50px rgba(0,212,184,0.25)' } }}>
                  {window.electronAPI ? <>{I.monitor}&nbsp; Open Dashboard</> : (isDownloading ? 'Processing...' : <>{I.dl}&nbsp; Download Netwoke for macOS</>)}
                </button>
                <div style={{ marginTop: 14, fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--faint)', letterSpacing: '0.05em' }}>
                  macOS 12+ · Apple Silicon &amp; Intel · v1.0.2 · ~132.7 MB
                </div>
              </div>
            </div>
            <div className="nw-reveal trust-row">
              {[[I.shield,'Signed & Notarized'],[I.github,'ZeroDarkHub'],[I.home,'100% Local'],[I.slash,'No Account']].map(([ic,lbl]) => (
                <div key={lbl} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 9 }}>
                  <div style={{ width: 40, height: 40, borderRadius: 10, background: 'var(--surface)',
                    border: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{ic}</div>
                  <span style={{ fontSize: 11, color: 'var(--muted)' }}>{lbl}</span>
                </div>
              ))}
            </div>
          </section>

          {/* ── FOOTER ── */}
          <footer className="nw-footer" style={{ padding: '36px 48px 28px',
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
              <div style={{ width: 28, height: 28, borderRadius: 7, overflow: 'hidden', flexShrink: 0 }}>
                <img src="/logo.png" alt="NetWatch" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <span style={{ fontFamily: 'var(--font-mono)', fontSize: 13, fontWeight: 600,
                color: 'var(--text)', letterSpacing: '0.06em' }}>Netwoke</span>
            </div>
            <div style={{ fontSize: 11, color: 'var(--accent-teal)', fontFamily: 'var(--font-mono)' }}>
              &copy; 2026 Netwoke - Where Connection Meets Disclosure.
            </div>
            <div className="nw-footer-links" style={{ display: 'flex', gap: 20 }}>
              <a href="https://x.com/netwokeapp" target="_blank" rel="noopener noreferrer"
                style={{ fontSize: 11, color: 'var(--faint)', fontFamily: 'var(--font-mono)',
                  cursor: 'pointer', transition: 'color .15s', textDecoration: 'none',
                  display: 'flex', alignItems: 'center', gap: 5 }}
                onMouseEnter={e => e.currentTarget.style.color='var(--muted)'}
                onMouseLeave={e => e.currentTarget.style.color='var(--faint)'}>
                𝕏 @NetwokeApp
              </a>
              {['Privacy Policy'].map(l => (
                <span key={l} onClick={() => {
                  if (l === 'Privacy Policy') window.location.hash = '#privacy'
                }}
                  style={{ fontSize: 11, color: 'var(--faint)', fontFamily: 'var(--font-mono)',
                    cursor: 'pointer', transition: 'color 0.15s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.color='var(--muted)'}
                  onMouseLeave={e => e.currentTarget.style.color='var(--faint)'}>
                  {l}
                </span>
              ))}
            </div>
          </footer>

        </div>
      </div>
    </>
  )
}
